



































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import JwtStorageService from '../../../services/shared/auth/jwt-storage.service';
import analysisComponentRouter from '@/router/modules/analysis-component';
import AdminService from '../../../services/admin.service';
import { AdminDto } from '@/dto';
import { BaseUser } from '@/services/shared/auth';
import NavBarList from '../NavBar/NavBarList.layout.vue';
import NavBarAccount from '../NavBar/NavBarAccount.layout.vue';

@Component({
  name: 'AnalysisLayout',
  components: {
    NavBarList,
    NavBarAccount,
  },
})
export default class AnalysisLayout extends BaseComponent {
  private items = analysisComponentRouter;
}
